/** Display helpers for stay rows in account / bookings lists. */

export function getStayInfoFromBooking(booking) {
  const stay = booking?.stay || booking?.staySnapshot || null;
  const title = (stay?.title || stay?.name || '').trim() || 'Stay';
  const image = stay?.images?.[0] || null;
  const location = formatStayLocation(stay);
  return { title, image, location, stay };
}

export function formatStayLocation(stay) {
  if (!stay) return 'Location not available';
  const cityState = [stay.city, stay.state].filter(Boolean).join(', ');
  if (cityState) return cityState;
  const address = (stay.address || stay.location || '').trim();
  if (address) return address;
  return 'Location not available';
}
